import { useSelector } from "react-redux";
import LandingPageStepFour from "../components/landing-columns/LandingPageStepFour";
import LandingPageStepOne from "../components/landing-columns/LandingPageStepOne";
import LandingPageStepThree from "../components/landing-columns/LandingPageStepThree";
import LandingPageStepTwo from "../components/landing-columns/LandingPageStepTwo";
import {
    setVisitors,
    setActivityTiming,
    setCurrentStep,
    setSelectedActivity,
    setColumnMessage,
    setFlowType, setSteps
} from "../store/MahutiReducer";
import {FLOW_TYPE, PAGES, PREFIX_PATH, scrollToSection} from "./GlobalParams";
import { isMobile } from "react-device-detect";

export const flowTypeDate = 'dateflow';
export const flowTypeActivity = 'activityflow';

export const mySteps = [
    { title: 'בחר תאריך', name: 'dateSelection', isCurrent: true, stepOrder: 0, disabled: true },
    { title: 'בחר פעילות', name: 'activitySelection', isCurrent: false, stepOrder: 1, disabled: true },
    { title: 'בחר שעה', name: 'timeSelection', isCurrent: false, stepOrder: 2, disabled: true },
    { title: 'סיום רכישה', name: 'finish', isCurrent: false, stepOrder: 3, disabled: true },
]

export const myStepsMOBILE = [
    { title: 'תאריך', name: 'dateSelection', isCurrent: true, stepOrder: 0, disabled: true  },
    { title: 'פעילות', name: 'activitySelection', isCurrent: false, stepOrder: 1, disabled: true  },
    { title: 'שעה', name: 'timeSelection', isCurrent: false, stepOrder: 2, disabled: true  },
    { title: 'סיום', name: 'finish', isCurrent: false, stepOrder: 3, disabled: true  },
]

export const myStepsActivity = [
    { title: 'בחר תאריך', name: 'dateSelection', isCurrent: true, stepOrder: 0, disabled: true },
    { title: 'בחר שעה', name: 'timeSelection', isCurrent: false, stepOrder: 1, disabled: true },
    { title: 'סיום רכישה', name: 'finish', isCurrent: false, stepOrder: 2, disabled: true },
]

export const myStepsActivityMOBILE = [
    { title: 'תאריך', name: 'dateSelection', isCurrent: true, stepOrder: 0, disabled: true },
    { title: 'שעה', name: 'timeSelection', isCurrent: false, stepOrder: 1, disabled: true },
    { title: 'סיום', name: 'finish', isCurrent: false, stepOrder: 2, disabled: true },
]

export const currectStepComponent = (currentStep, props) => {
    if (currentStep === 0) return <LandingPageStepOne />;
    else if (currentStep === 1) return <LandingPageStepTwo />;
    else if (currentStep === 2) return <LandingPageStepThree />;
    else return <LandingPageStepFour />;
}

export const currectStepActivityComponent = (currentStep) => {

    if (currentStep === 0) return <LandingPageStepOne />;
    else if (currentStep === 1) return <LandingPageStepThree />;
    else return <LandingPageStepFour />;
}

export const nextBtnTextDateFlow = (currentStep) => {
    if (currentStep === 0) return 'הבא';
    else if (currentStep === 1) return 'הבא';
    else if (currentStep === 2) return 'הבא';
    else return 'לתשלום';
}

export const nextBtnTextActivityFlow = (currentStep) => {
    if (currentStep === 0) return 'הבא';
    else if (currentStep === 1) return 'הבא';
    else return 'לתשלום';
}

export const onBrowserBackButtonHandle = (store, dispatch, navigate, location, customFn) => {

    window.onpopstate = (e) => {
        console.log('back path:', location.pathname, 'step', store.currentStep);
        customFn && customFn()
        e.preventDefault();
        dispatch(setColumnMessage())
        if (store.currentStep === 0 || !store.currentStep) {
          dispatch(setActivityTiming(undefined))
          dispatch(setVisitors({adults: 1, underAge: 1}))
          dispatch(setSelectedActivity(undefined))
        }else{
            let lpPrefix = store.lpName ? '/' + store.lpName : '';
            console.log(PREFIX_PATH + lpPrefix + '/' + PAGES.PAYMENT_PAGE)
            console.log(location.pathname)
            if(location.pathname ===  PREFIX_PATH + lpPrefix + '/' + PAGES.PAYMENT_PAGE) {
                console.log("back from payment page")
                dispatch(setCurrentStep(3))
                navigate(PREFIX_PATH + lpPrefix + '/' + PAGES.DATE_FLOW)
            }else{
                console.log("regular back")
                navigate(location.pathname);
                dispatch(setCurrentStep(store.currentStep - 1))
                setTimeout(function(){
                    scrollToSection('sellingflow_view');
                },1000) 
          }
        }
      }
}

export const onBrowserRefreshHandle = (store, dispatch) => {
    // onrefresh

    // window.onbeforeunload = (e) => {
    //     console.log('ON Refresh click');

    //     // Show prompt based on state
    //     window.event.preventDefault();
    //     if (e) {
    //         e.returnValue = ''
    //     }
    //     return '';

    // }

}

